import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './permission'

// 引入饿了么UI
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element, { size: 'small', zIndex: 3000 });
import '@/static/css/style.css' // global css

//基于vue的移动端音频播放器（语音条外观）
// import audio from 'vue-mobile-audio'
// Vue.use(audio)

Vue.config.productionTip = false

import store from '../store'

// 引入图表
import ECharts from 'vue-echarts'
// 全局注册组件（也可以使用局部注册）
Vue.component('v-chart', ECharts)
// import { use } from 'echarts/core'
// 手动引入 ECharts 各模块来减小打包体积

// import {
//   CanvasRenderer
// } from 'echarts/renderers'
// import {
//   BarChart
// } from 'echarts/charts'
// import {
//   GridComponent,
//   TooltipComponent
// } from 'echarts/components'

// use([
//   CanvasRenderer,
//   BarChart,
//   GridComponent,
//   TooltipComponent
// ]);



// 非超级管理员登录要动态添加路由
// import {getToken} from '@/tool/cookie'
// import storage from 'good-storage'
// let login_uid = getToken('login_uid');
// if(login_uid && login_uid !=1){
// 	let router_1 = JSON.parse(storage.get('manager_role'));
// 	router.addRoutes(router_1)
// 	console.log(router_1)
// }


new Vue({
	store,
	router,
	render: h => h(App)
}).$mount("#app")
